export default __webpack_public_path__ + "static/media/icon_document_regular_active.11528af7.svg";